import {UserRole} from './user'

export interface AuthEnterprise {
  contactName: string
  countryCode: string
  emailAddress: string
  id: string
  name: string
  phoneNumber: string
  timezone: string
}

export interface AuthUser {
  emailAddress: string
  enterpriseId: string
  id: string
  name: string
  phoneNumber: string
  type: UserRole
  username: string
}

export interface AuthModel {
  user: AuthUser | null
  enterprise: AuthEnterprise | null
  session_id: string | null
}

export const initialAuthModel: AuthModel = {
  enterprise: null,
  user: null,
  session_id: null,
}
